// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PMcumbgN7dPuw1 {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.PMcumbgN7dPuw1 > .header-banner,
.PMcumbgN7dPuw1 > #header {
  flex: none;
}
`, ""]);
// Exports
export var surface = `PMcumbgN7dPuw1`;
export default ___CSS_LOADER_EXPORT___;
